// import { Fragment, useState } from 'react'
// import { Dialog, Popover, Tab, Transition } from '@headlessui/react'
// import { Bars3Icon, MagnifyingGlassIcon, ShoppingBagIcon, XMarkIcon } from '@heroicons/react/24/outline'
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation } from "react-router-dom";
// const navigation = {
//   categories: [
//     {
//       id: 'nu',
//       name: 'Nữ',
//       sections: [
//         { name: 'Sản phẩm mới', href: '/nu/tat-ca-san-pham-nu.html', image: '/images/tat-ca-san-pham-nu.png' },
//         { name: 'Áo thun nữ polo', href: '/nu/ao-thun-nu-polo.html', image: '/images/ao-thun-nu-polo.png' },
//         { name: 'Áo thun nữ tay ngắn', href: '/nu/ao-thun-nu-tay-ngan.html', image: '/images/ao-thun-nu-tay-ngan.png' },
//         { name: 'Áo thun nữ tay dài', href: '/nu/ao-thun-nu-tay-dai.html', image: '/images/ao-thun-nu-tay-dai.png' },
//         { name: 'Áo sơ mi nữ tay ngắn', href: '/nu/ao-so-mi-nu-tay-ngan.html', image: '/images/ao-so-mi-nu-tay-ngan.png' },
//         { name: 'Áo sơ mi nữ tay dài', href: '/nu/ao-so-mi-nu-tay-dai.html', image: '/images/ao-so-mi-nu-tay-dai.png' },
//         { name: 'Áo len', href: '/nu/ao-len-nu.html', image: '/images/ao-len-nu.png' },
//         { name: 'Áo đầm', href: '/nu/ao-dam.html', image: '/images/ao-dam.png' },
//         { name: 'Áo khoác', href: '/nu/ao-khoac-jeans-nu.html', image: '/images/ao-khoac-nu.png' },
//         { name: 'Áo hoodie', href: '/nu/ao-hoodie-nu.html', image: '/images/ao-hoodie-nu.png' },
//         { name: 'Áo gile', href: '/nu/ao-gile-nu.html', image: '/images/ao-gile.png' },
//         { name: 'Áo sweater', href: '/nu/ao-sweater-nu.html', image: '/images/ao-sweater-nu.png' },
//         { name: 'Quần jeans', href: '/nu/quan-jeans-nu.html', image: '/images/quan-jeans-nu.png' },
//         { name: 'Quần short', href: '/nu/quan-short-nu.html', image: '/images/quan-short-nu.png' },
//         { name: 'Váy', href: '/nu/vay.html', image: '/images/vay.png' },
//         { name: 'Quần tây - kaki', href: '/nu/quan-tay-nu.html', image: '/images/quan-tay-nu.png' },

//       ],
//     },
//     {
//       id: 'nam',
//       name: 'Nam',

//       sections: [

//         { name: 'Sản phẩm mới', href: '/nam/tat-ca-san-pham-nam.html', image: '/images/tat-ca-san-pham-nam.png' },
//         { name: 'Áo thun nam polo', href: '/nam/ao-thun-nam-polo.html', image: '/images/ao-thun-nam-polo.png' },
//         { name: 'Áo thun nam tay ngắn', href: '/nam/ao-thun-nam-tay-ngan.html', image: '/images/ao-thun-nam-tay-ngan.png' },
//         { name: 'Áo thun nam tay dài', href: '/nam/ao-thun-nam-tay-dai.html', image: '/images/ao-thun-nam-tay-dai.png' },
//         { name: 'Áo sơ mi tay ngắn', href: '/nam/ao-so-mi-nam-tay-ngan.html', image: '/images/ao-so-mi-nam-tay-ngan.png' },
//         { name: 'Áo sơ mi tay dài', href: '/nam/ao-so-mi-nam-tay-dai.html', image: '/images/ao-so-mi-nam-tay-dai.png' },
//         { name: 'Áo len', href: '/nam/ao-len-nam.html', image: '/images/ao-len-nam.png' },
//         { name: 'Áo khoác', href: '/nam/ao-khoac-jeans-nam.html', image: '/images/ao-khoac-nam.png' },
//         { name: 'Áo sweater', href: '/nam/ao-sweater-nam.html', image: '/images/ao-sweater-nam.png' },
//         { name: 'Áo hoodie', href: '/nam/ao-hoodie-nam.html', image: '/images/ao-hoodie-nam.png' },
//         { name: 'Quần jeans', href: '/nam/quan-jeans-nam.html', image: '/images/quan-jeans-nam.png' },
//         { name: 'Quần short', href: '/nam/quan-short-nam.html', image: '/images/quan-short-nam.png' },
//         { name: 'Quần tây', href: '/nam/quan-tay-nam.html', image: '/images/quan-tay-nam.png' },
//         { name: 'Quần kaki', href: '/nam/quan-kaki-nam.html', image: '/images/quan-kaki-nam.png' },
//         { name: 'Quần thể thao', href: '/nam/quan-the-thao-nam.html', image: '/images/quan-the-thao-nam.png' },

//       ],
//     },
//     {
//       id: 'phukien',
//       name: 'Phụ kiện',
//       sections: [
//         { name: 'Sản phẩm mới', href: '/phu-kien/tat-ca-phu-kien.html', image: '/images/tat-ca-phu-kien.png' },
//         { name: 'Dây nịt', href: '/phu-kien/day-nit.html', image: '/images/day-nit.png' },
//         { name: 'Nón', href: '/phu-kien/non.html', image: '/images/non.png' },
//         { name: 'Túi xách', href: '/phu-kien/tui-xach.html', image: '/images/tui-xach.png' },
//         { name: 'Bóp', href: '/phu-kien/bop.html', image: '/images/bop.png' },
//         { name: 'Caravat', href: '/phu-kien/caravat.html', image: '/images/caravat.png' },
//         { name: 'Giày', href: '/phu-kien/giay.html', image: '/images/giay.png' },
//         { name: 'Dép', href: '/phu-kien/dep.html', image: '/images/dep.png' },
//         { name: 'Khăn', href: '/phu-kien/khan.html', image: '/images/khan.png' },
//       ],
//     },
//   ],
//   pages: [
//     { name: 'Limited edition', href: '/limited-edition.html' },
//     //{ name: 'Cửa hàng', href: '/cua-hang.html' },
//     // { name: 'Tuyển dụng', href: '/tuyen-dung.html' },
//   ],
// }

// function classNames(...classes) {
//   return classes.filter(Boolean).join(' ')
// }

// export default function Header() {
//   const [open, setOpen] = useState(false)
//   const { cart } = useSelector(store => store)
//   const location = useLocation();
//   const isHome = location.pathname === "/";
//   return (
//     <div className=" absolute top-0 left-0 w-full  z-40">
//       {/* Mobile menu */}
//       <Transition.Root show={open} as={Fragment}>
//         <Dialog as="div" className="relative z-51 lg:hidden" onClose={setOpen}>
//           <Transition.Child
//             as={Fragment}
//             enter="transition-opacity ease-linear duration-300"
//             enterFrom="opacity-0"
//             enterTo="opacity-100"
//             leave="transition-opacity ease-linear duration-300"
//             leaveFrom="opacity-100"
//             leaveTo="opacity-0"
//           >
//             <div className="fixed inset-0 bg-black bg-opacity-25" />
//           </Transition.Child>

//           <div className="fixed inset-0 z-40 flex">
//             <Transition.Child
//               as={Fragment}
//               enter="transition ease-in-out duration-300 transform"
//               enterFrom="-translate-x-full"
//               enterTo="translate-x-0"
//               leave="transition ease-in-out duration-300 transform"
//               leaveFrom="translate-x-0"
//               leaveTo="-translate-x-full"
//             >
//               <Dialog.Panel className="relative flex w-full max-w-xs flex-col overflow-y-auto bg-white pb-12 shadow-xl">
//                 <div className="flex px-4 pb-2 pt-5">
//                   <button
//                     type="button"
//                     className="relative -m-2 inline-flex items-center justify-center rounded-md p-2 text-gray-400"
//                     onClick={() => setOpen(false)}
//                   >
//                     <span className="absolute -inset-0.5" />
//                     <span className="sr-only">Close menu</span>
//                     <XMarkIcon className="h-6 w-6" aria-hidden="true" />
//                   </button>
//                 </div>

//                 <Tab.Group as="div" className="mt-2">
//                   <div className="border-transparent border-gray-200">
//                     <Tab.List className="-mb-px flex space-x-4 px-4">
//                       {navigation.categories.map((category) => (
//                         <Tab
//                           key={category.name}
//                           className={({ selected }) =>
//                             classNames(
//                               selected ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-900',
//                               'flex-1 whitespace-nowrap border-transparent px-1 py-2 text-base font-medium'
//                             )
//                           }
//                         >
//                           {category.name}
//                         </Tab>
//                       ))}
//                     </Tab.List>
//                   </div>
//                   <Tab.Panels as={Fragment}>
//                     {navigation.categories.map((category) => (
//                       <Tab.Panel key={category.name} className="space-y-0 px-2 pb-4 pt-0">
//                         {category.sections.map((section) => (
//                          <ul
//                          role="list"
//                          aria-labelledby={`${section.name}-heading`}
//                          className="mt-6 space-y-3 sm:mt-4 sm:space-y-4"
//                        >
//                          <li key={section.name} className="flex items-center">
//                            <a
//                              href={section.href}
//                              className="flex items-center space-x-2 p-3 rounded-lg hover:bg-gray-200 transition duration-200"
//                            >
//                              <img className="h-10 w-10 rounded-full" src={section.image} alt={section.name} />
//                              <span className="text-lg font-semibold text-gray-900">{section.name}</span>
//                            </a>
//                          </li>
//                        </ul>
//                         ))}
//                       </Tab.Panel>
//                     ))}
//                   </Tab.Panels>
//                 </Tab.Group>
//                 <div className="space-y-6 border-t border-gray-200 px-4 py-6">
//                   {navigation.pages.map((page) => (
//                     <div key={page.name} className="flow-root">
//                       <a href={page.href} className="-m-2 block p-2 font-medium text-gray-900">
//                         {page.name}
//                       </a>
//                     </div>
//                   ))}
//                 </div>
//               </Dialog.Panel>
//             </Transition.Child>
//           </div>
//         </Dialog>
//       </Transition.Root>
//       <header className="">
//         <p className="flex h-10 items-center justify-center px-4 text-sm font-medium text-white sm:px-6 lg:px-8">
//           {/* Logo */}
//           {!isHome && (
//           <div className="ml-4 flex lg:ml-0">
//             <a href='/'>
//               <span className="sr-only">PT2000</span>
//               <img
//                 className="h-8 w-auto"
//                 src='/logopt2000.png'
//                 alt="Logo PT2000"
//               />
//             </a>
//           </div>
//           )}
//         </p>

//         <nav aria-label="Top" className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

//           <div className="border-transparent border-gray-200">
//             <div className="flex h-4 items-center">

//               <button
//                 type="button"
//                 className="relative rounded-md  p-2 text-gray-400 lg:hidden"
//                 onClick={() => setOpen(true)}
//               >
//                 <span className="absolute -inset-0.5" />
//                 <span className="sr-only">Open menu</span>
//                 <Bars3Icon className="h-6 w-6" aria-hidden="true" />
//               </button>
//               {/* Flyout menus */}
//               <Popover.Group className="hidden lg:ml-8 lg:block lg:self-stretch">
//                 <div className="flex h-full space-x-8">
//                   {navigation.categories.map((category) => (
//                     <Popover key={category.name} className="flex">

//                       {({ open }) => (
//                         <>
//                           <div className="relative flex">
//                             <Popover.Button
//                               className={classNames(
//                                 'text-gray-700 hover:text-gray-800', // Màu chữ khi không chọn và khi hover
//                                 'relative z-10 -mb-px flex items-center pt-px text-sm font-medium transition-colors duration-200 ease-out',
//                                 'focus:outline-none', // Xóa outline khi nhấp vào
//                                 open ? 'border-b-2 border-gray-500' : '', // Thêm underline màu xám khi nhấp vào
//                                 'py-1' // Thêm padding dọc để giảm chiều cao
//                               )}
//                             >
//                               {category.name}
//                             </Popover.Button>

//                           </div>
//                           <Transition
//                             as={Fragment}
//                             enter="transition ease-out duration-200"
//                             enterFrom="opacity-0"
//                             enterTo="opacity-100"
//                             leave="transition ease-in duration-150"
//                             leaveFrom="opacity-100"
//                             leaveTo="opacity-0"
//                           >
//                             <Popover.Panel className="absolute inset-x-0 top-full text-sm text-gray-500">
//                               {/* Presentational element used to render the bottom shadow, if we put the shadow on the actual panel it pokes out the top, so we use this shorter element to hide the top of the shadow */}
//                               <div className="absolute inset-0 top-1/2" aria-hidden="true" />

//                               <div className="relative">
//                                 <div className="mx-auto max-w-7xl px-8">
//                                   <div className="grid grid-cols-1 gap-x-8 gap-y-10 pt-1 py-2 ">
//                                     <div className="row-start-1 grid grid-cols-4 gap-x-4 gap-y-2 text-sm bg-white pl-7  rounded-lg shadow-md mb-6 z-50">  
//                                       {/* --Màu nền menu here */}

//                                       {/* <div className=' col-span-3' ><a href={`${category.id === 'nu' ? '/nu/tat-ca-san-pham-nu.html' : category.id === 'nam' ? '/nam/tat-ca-san-pham-nam.html' : '/phu-kien/tat-ca-phu-kien.html'}`}>Tất cả sảm phẩm</a></div> */}

//                                       {category.sections.map((section) => (
//                                         <ul
//                                           role="list"
//                                           aria-labelledby={`${section.name}-heading`}
//                                           className="mt-6 space-y-6 sm:mt-4 sm:space-y-4"
//                                         >
//                                           <li key={section.name} className="flex items-center">
//                                             <a
//                                               href={section.href}
//                                               className="flex items-center space-x-4 p-4 rounded-lg hover:bg-gray-200 transition duration-200"
//                                             >
//                                               <img className="h-10 w-10 rounded-full" src={section.image} alt={section.name} />
//                                               <span className="text-lg font-semibold text-gray-900">{section.name}</span>
//                                             </a>
//                                           </li>
//                                         </ul>


//                                       ))}
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             </Popover.Panel>
//                           </Transition>
//                         </>
//                       )}
//                     </Popover>
//                   ))}

//                   {navigation.pages.map((page) => (
//                     <a
//                       key={page.name}
//                       href={page.href}
//                       className="flex items-center text-sm font-medium text-gray-700 hover:text-gray-800"
//                     >
//                       {page.name}
//                     </a>
//                   ))}
//                 </div>
//               </Popover.Group>
//               <div className="ml-auto flex items-center">
//                 {/* Search */}
//                 <div className="flex lg:ml-6">
//                   <a href="/tim-kiem.html" className="p-2 text-gray-400 hover:text-gray-500">
//                     <span className="sr-only">Search</span>
//                     <MagnifyingGlassIcon className="h-6 w-6" aria-hidden="true" />
//                   </a>
//                 </div>
//                 {/* Cart */}
//                 <div className="ml-4 flow-root lg:ml-6">
//                   <a href="/gio-hang.html" className="group -m-2 flex items-center p-2">
//                     <ShoppingBagIcon
//                       className="h-6 w-6 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
//                       aria-hidden="true"
//                     />
//                     <span className="ml-2 text-sm font-medium text-gray-700 group-hover:text-gray-800">
//                       {cart.totalQuantity} 
//                     </span>
//                     <span className="sr-only">items in cart, view bag</span>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </nav>
//       </header>
//     </div>
//   )
// }
import { Fragment, useState } from "react";
import { Dialog, Popover, Tab, Transition } from "@headlessui/react";
import {
  Bars3Icon,
  MagnifyingGlassIcon,
  ShoppingBagIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useSelector } from "react-redux";
import { useLocation, Link } from "react-router-dom";

const navigation = {
  categories: [
    {
      id: "nu",
      name: "Nữ",
      sections: [
        { name: "Sản phẩm mới", href: "/nu/tat-ca-san-pham-nu.html", image: "/images/tat-ca-san-pham-nu.png" },
        { name: "Áo thun nữ polo", href: "/nu/ao-thun-nu-polo.html", image: "/images/ao-thun-nu-polo.png" },
        { name: "Áo thun nữ tay ngắn", href: "/nu/ao-thun-nu-tay-ngan.html", image: "/images/ao-thun-nu-tay-ngan.png" },
        { name: "Áo thun nữ tay dài", href: "/nu/ao-thun-nu-tay-dai.html", image: "/images/ao-thun-nu-tay-dai.png" },
        { name: "Áo sơ mi nữ tay ngắn", href: "/nu/ao-so-mi-nu-tay-ngan.html", image: "/images/ao-so-mi-nu-tay-ngan.png" },
        { name: "Áo sơ mi nữ tay dài", href: "/nu/ao-so-mi-nu-tay-dai.html", image: "/images/ao-so-mi-nu-tay-dai.png" },
        { name: "Áo len", href: "/nu/ao-len-nu.html", image: "/images/ao-len-nu.png" },
        { name: "Áo đầm", href: "/nu/ao-dam.html", image: "/images/ao-dam.png" },
        { name: "Áo khoác", href: "/nu/ao-khoac-jeans-nu.html", image: "/images/ao-khoac-nu.png" },
        { name: "Áo hoodie", href: "/nu/ao-hoodie-nu.html", image: "/images/ao-hoodie-nu.png" },
        { name: "Áo gile", href: "/nu/ao-gile-nu.html", image: "/images/ao-gile.png" },
        { name: "Áo sweater", href: "/nu/ao-sweater-nu.html", image: "/images/ao-sweater-nu.png" },
        { name: "Quần jeans", href: "/nu/quan-jeans-nu.html", image: "/images/quan-jeans-nu.png" },
        { name: "Quần short", href: "/nu/quan-short-nu.html", image: "/images/quan-short-nu.png" },
        { name: "Váy", href: "/nu/vay.html", image: "/images/vay.png" },
        { name: "Quần tây - kaki", href: "/nu/quan-tay-nu.html", image: "/images/quan-tay-nu.png" },
      ],
    },
    {
      id: "nam",
      name: "Nam",
      sections: [
        { name: "Sản phẩm mới", href: "/nam/tat-ca-san-pham-nam.html", image: "/images/tat-ca-san-pham-nam.png" },
        { name: "Áo thun nam polo", href: "/nam/ao-thun-nam-polo.html", image: "/images/ao-thun-nam-polo.png" },
        { name: "Áo thun nam tay ngắn", href: "/nam/ao-thun-nam-tay-ngan.html", image: "/images/ao-thun-nam-tay-ngan.png" },
        { name: "Áo thun nam tay dài", href: "/nam/ao-thun-nam-tay-dai.html", image: "/images/ao-thun-nam-tay-dai.png" },
        { name: "Áo sơ mi tay ngắn", href: "/nam/ao-so-mi-nam-tay-ngan.html", image: "/images/ao-so-mi-nam-tay-ngan.png" },
        { name: "Áo sơ mi tay dài", href: "/nam/ao-so-mi-nam-tay-dai.html", image: "/images/ao-so-mi-nam-tay-dai.png" },
        { name: "Áo len", href: "/nam/ao-len-nam.html", image: "/images/ao-len-nam.png" },
        { name: "Áo khoác", href: "/nam/ao-khoac-jeans-nam.html", image: "/images/ao-khoac-nam.png" },
        { name: "Áo sweater", href: "/nam/ao-sweater-nam.html", image: "/images/ao-sweater-nam.png" },
        { name: "Áo hoodie", href: "/nam/ao-hoodie-nam.html", image: "/images/ao-hoodie-nam.png" },
        { name: "Quần jeans", href: "/nam/quan-jeans-nam.html", image: "/images/quan-jeans-nam.png" },
        { name: "Quần short", href: "/nam/quan-short-nam.html", image: "/images/quan-short-nam.png" },
        { name: "Quần tây", href: "/nam/quan-tay-nam.html", image: "/images/quan-tay-nam.png" },
        { name: "Quần kaki", href: "/nam/quan-kaki-nam.html", image: "/images/quan-kaki-nam.png" },
        { name: "Quần thể thao", href: "/nam/quan-the-thao-nam.html", image: "/images/quan-the-thao-nam.png" },
      ],
    },
    {
      id: "phukien",
      name: "Phụ kiện",
      sections: [
        { name: "Sản phẩm mới", href: "/phu-kien/tat-ca-phu-kien.html", image: "/images/tat-ca-phu-kien.png" },
        { name: "Dây nịt", href: "/phu-kien/day-nit.html", image: "/images/day-nit.png" },
        { name: "Nón", href: "/phu-kien/non.html", image: "/images/non.png" },
        { name: "Túi xách", href: "/phu-kien/tui-xach.html", image: "/images/tui-xach.png" },
        { name: "Bóp", href: "/phu-kien/bop.html", image: "/images/bop.png" },
        { name: "Caravat", href: "/phu-kien/caravat.html", image: "/images/caravat.png" },
        { name: "Giày", href: "/phu-kien/giay.html", image: "/images/giay.png" },
        { name: "Dép", href: "/phu-kien/dep.html", image: "/images/dep.png" },
        { name: "Khăn", href: "/phu-kien/khan.html", image: "/images/khan.png" },
      ],
    },
  ],
  pages: [
    { name: "Limited edition", href: "/limited-edition.html" },
  ],
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function isLimitedPage(pageName) {
  return pageName?.toLowerCase() === "limited edition";
}

export default function Header() {
  const [open, setOpen] = useState(false);
  const { cart } = useSelector((store) => store);
  const location = useLocation();

  const isHome = location.pathname === "/";
  const cartQty = cart?.totalQuantity ?? 0;

  return (
    <header className="absolute left-0 top-0 z-40 w-full">
      {/* Mobile menu */}
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-[70] lg:hidden" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/30 backdrop-blur-[1px]" />
          </Transition.Child>

          <div className="fixed inset-0 z-[70] flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-250 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="flex h-full w-[90vw] max-w-sm flex-col bg-white shadow-2xl">
                {/* Mobile header */}
                <div className="flex items-center justify-between border-b border-gray-100 px-4 py-4">
                  <div className="text-sm font-semibold text-gray-900">Danh mục</div>
                  <button
                    type="button"
                    className="rounded-md p-2 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700"
                    onClick={() => setOpen(false)}
                  >
                    <span className="sr-only">Close menu</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>

                {/* Mobile categories */}
                <div className="flex-1 overflow-y-auto">
                  <Tab.Group as="div" className="flex h-full flex-col">
                    <div className="sticky top-0 z-10 border-b border-gray-100 bg-white px-3 py-2">
                      <Tab.List className="flex gap-2 overflow-x-auto">
                        {navigation.categories.map((category) => (
                          <Tab
                            key={category.name}
                            className={({ selected }) =>
                              classNames(
                                selected
                                  ? "bg-gray-900 text-white"
                                  : "bg-gray-100 text-gray-700 hover:bg-gray-200",
                                "whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium outline-none transition"
                              )
                            }
                          >
                            {category.name}
                          </Tab>
                        ))}
                      </Tab.List>
                    </div>

                    <Tab.Panels className="flex-1 px-3 py-3">
                      {navigation.categories.map((category) => (
                        <Tab.Panel key={category.name} className="focus:outline-none">
                          <ul className="space-y-2">
                            {category.sections.map((section) => (
                              <li key={section.name}>
                                <Link
                                  to={section.href}
                                  className="flex items-center gap-3 rounded-xl p-3 transition hover:bg-gray-50"
                                  onClick={() => setOpen(false)}
                                >
                                  <img
                                    className="h-12 w-12 flex-shrink-0 rounded-full object-cover ring-1 ring-gray-200"
                                    src={section.image}
                                    alt={section.name}
                                  />
                                  <span className="text-sm font-semibold text-gray-900">
                                    {section.name}
                                  </span>
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </Tab.Panel>
                      ))}
                    </Tab.Panels>
                  </Tab.Group>
                </div>

                {/* Mobile pages footer */}
                <div className="shrink-0 border-t border-gray-100 px-4 py-4">
                  <div className="space-y-2">
                    {navigation.pages.map((page) => (
                      <Link
                        key={page.name}
                        to={page.href}
                        className={classNames(
                          "block rounded-xl px-3 py-3 text-sm font-medium transition",
                          isLimitedPage(page.name)
                            ? "font-bold uppercase tracking-wide text-red-700 hover:bg-red-50 hover:text-red-800"
                            : "text-gray-900 hover:bg-gray-50"
                        )}
                        onClick={() => setOpen(false)}
                      >
                        {page.name}
                      </Link>
                    ))}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>

      {/* Top logo row */}
      <div className="flex min-h-[40px] items-center justify-center px-4 sm:px-6 lg:px-8">
        {!isHome && (
          <Link to="/" className="inline-flex items-center">
            <span className="sr-only">PT2000</span>
            <img
              className="h-8 w-auto object-contain"
              src="/logopt2000.png"
              alt="Logo PT2000"
            />
          </Link>
        )}
      </div>

      {/* Main nav */}
      <nav aria-label="Top" className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative flex h-12 items-center">
          {/* Mobile button */}
          <div className="flex items-center lg:hidden">
            <button
              type="button"
              className="rounded-md p-2 text-gray-500 transition hover:bg-white/10 hover:text-gray-700"
              onClick={() => setOpen(true)}
            >
              <span className="sr-only">Open menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>

          {/* Desktop nav */}
          <div className="hidden flex-1 items-center lg:flex">
            {/* Categories */}
            <div className="flex items-center gap-8">
              {navigation.categories.map((category) => (
                <Popover key={category.name} className="relative">
                  {({ open }) => (
                    <>
                      <Popover.Button
                        className={classNames(
                          "inline-flex items-center border-b-2 px-1 py-1 text-sm font-medium transition-colors focus:outline-none",
                          open
                            ? "border-gray-900 text-gray-900"
                            : "border-transparent text-gray-700 hover:border-gray-300 hover:text-gray-900"
                        )}
                      >
                        {category.name}
                      </Popover.Button>

                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0 translate-y-1"
                        enterTo="opacity-100 translate-y-0"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 translate-y-0"
                        leaveTo="opacity-0 translate-y-1"
                      >
                        <Popover.Panel className="absolute left-0 top-full z-50 pt-4">
                          <div className="w-[920px] rounded-2xl bg-white p-5 shadow-2xl ring-1 ring-black/5">
                            <div className="grid grid-cols-4 gap-3">
                              {category.sections.map((section) => (
                                <Link
                                  key={section.name}
                                  to={section.href}
                                  className="flex items-center gap-3 rounded-xl p-3 transition hover:bg-gray-50"
                                >
                                  <img
                                    className="h-11 w-11 flex-shrink-0 rounded-full object-cover ring-1 ring-gray-200"
                                    src={section.image}
                                    alt={section.name}
                                  />
                                  <span className="text-sm font-medium text-gray-900">
                                    {section.name}
                                  </span>
                                </Link>
                              ))}
                            </div>
                          </div>
                        </Popover.Panel>
                      </Transition>
                    </>
                  )}
                </Popover>
              ))}
            </div>

            {/* Pages */}
            <div className="ml-8 flex items-center gap-6">
              {navigation.pages.map((page) => (
                <Link
                  key={page.name}
                  to={page.href}
                  className={classNames(
                    "text-sm font-medium transition",
                    isLimitedPage(page.name)
                      ? "font-bold uppercase tracking-wide text-red-700 hover:text-red-800"
                      : "text-gray-700 hover:text-gray-900"
                  )}
                >
                  {page.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Right actions */}
          <div className="ml-auto flex items-center">
            <Link
              to="/tim-kiem.html"
              className="rounded-md p-2 text-gray-500 transition hover:bg-white/10 hover:text-gray-700"
            >
              <span className="sr-only">Search</span>
              <MagnifyingGlassIcon className="h-6 w-6" aria-hidden="true" />
            </Link>

            <Link
              to="/gio-hang.html"
              className="group ml-4 flex items-center rounded-md p-2 transition hover:bg-white/10"
            >
              <ShoppingBagIcon
                className="h-6 w-6 flex-shrink-0 text-gray-500 transition group-hover:text-gray-700"
                aria-hidden="true"
              />
              <span className="ml-2 text-sm font-medium text-gray-700 group-hover:text-gray-900">
                {cartQty}
              </span>
              <span className="sr-only">items in cart, view bag</span>
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
}